import React from "react";
import { Button } from "@mui/material";
import { makeStyles } from'@mui/styles';
import {
  StickerBlue,
  StickerOrange,
  Token14,
  Token50,
  Token64,
} from "styles/globalSVG";

const useStyles = makeStyles({
  upgradeButton: {
    position: "absolute",
    bottom: "20px",
    border: "1px solid #2eb790",
    boxSizing: "border-box",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    padding: "10px 40px",
    backgroundColor: "transparent",
  },

  textStyle: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: "18px",
    letterSpacing: "0.15px",
    color: "#2eb790",
    marginLeft: "0.3rem",
  },

  tokenStyle: {
    verticalAlign: "bottom",
  },
});

const CurrentPlan = () => (
  <div className="team-plan">
    <span className="current-plan">Current Plan</span>
  </div>
);

const TeamPlan = (props) => {
  const {
    setOpenUpgrade,
    setAsk,
    teamData,
    setPremiumPlan,
    setOrganizationPlan,
  } = props;

  //
  const classes = useStyles();

  // Ask user are they want to upgrade
  const openAskPremium = () => {
    setAsk(true);
    setOpenUpgrade(false);
    setPremiumPlan(true);
    setOrganizationPlan(false);
  };

  const openAskOrganization = () => {
    setAsk(true);
    setOpenUpgrade(false);
    setOrganizationPlan(true);
    setPremiumPlan(false);
  };

  const BasicTeam = () => {
    return (
      <div className="upgrade-basic">
        <div className="upgrade-team">
          <h1>Basic</h1>
          <p>10 members</p>
        </div>
        {teamData.type === "basic" && <CurrentPlan />}
      </div>
    );
  };

  const PremiumTeam = () => {
    return (
      <div className="upgrade-premium">
        <div className="sticker">
          <StickerBlue />
        </div>
        <div className="upgrade-team">
          <h1>Premium</h1>
          <p>100 members</p>
          <p>Private Teams</p>
        </div>
        {teamData.type === "basic" && (
          <Button className={classes.upgradeButton} onClick={openAskPremium} aria-label="Upgrade to Premium">
            <span className={classes.tokenStyle}>
              {teamData.type === "basic" ? <Token14 /> : null}
            </span>
          </Button>
        )}
        {teamData.type === "premium" && <CurrentPlan />}
      </div>
    );
  };

  const OrganizationTeam = () => {
    return (
      <div className="upgrade-premium">
        <div className="sticker">
          <StickerOrange />
        </div>
        <div className="upgrade-team">
          <h1>Organization</h1>
          <p>300 members</p>
          <p>Private Teams</p>
          <p>Team Promotion</p>
        </div>
        {(teamData.type === "basic" || teamData.type === "premium") && (
          <Button
            className={classes.upgradeButton}
            onClick={openAskOrganization}
            aria-label="Upgrade to Organization"
            >
            <span className="numb-passes">
              {teamData.type === "basic" ? <Token64 /> : <Token50 />}
            </span>
          </Button>
        )}
        {teamData.type === "organization" && <CurrentPlan />}
      </div>
    );
  };

  return (
    <>
      <BasicTeam />
      <PremiumTeam />
      <OrganizationTeam />
    </>
  );
};

export default TeamPlan;
